import type { JSX } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import SelectedCompanyProvider from '../../contexts/SelectedCompanyProvider'
import BrowsePromoMerchantsPage from '../BrowsePromoMerchantsPage'
import Promotions from '../BrowsePromotions'
import Territories from '../BrowseTerritories'
import EditBanner from '../EditBanner'
import EditMerchant from '../EditMerchant'
import Home from '../Home/HomePage'
import LoginPage from '../Home/LoginPage'
import Reports from '../Reports/Reports'
import ViewBanner from '../ViewBanner'
import ViewMerchant from '../ViewMerchant'
import AuthGuard from './components/AuthGuard'
import GuestGuard from './components/GuestGuard'
import TemplateApp from './components/TemplateApp'
import TemplateLogin from './components/TemplateLogin'

const TopLevelRoutes = (): JSX.Element => {
  return (
    <Routes>
      <Route element={<AuthGuard />}>
        <Route element={<SelectedCompanyProvider />}>
          <Route element={<TemplateApp />}>
            <Route path="/" element={<Navigate to="/merchant/browse" replace />} />
            <Route path="/merchant/browse" element={<Home />} />
            <Route path="home" element={<Home />} />
            <Route path="/territories" element={<Territories />} />
            <Route path="/promotions" element={<Promotions />} />
            <Route path="/promotions/:id/merchants" element={<BrowsePromoMerchantsPage />} />
            <Route path="/merchant/:id">
              <Route path="view" element={<ViewMerchant />} />
              <Route path="edit" element={<EditMerchant />} />
            </Route>
            <Route path="/banner/:id">
              <Route path="view" element={<ViewBanner />} />
              <Route path="edit" element={<EditBanner />} />
            </Route>
            <Route path="/reports" element={<Reports />} />
          </Route>
        </Route>
      </Route>
      <Route element={<GuestGuard />}>
        <Route element={<TemplateLogin />}>
          <Route path="login" element={<LoginPage />} />
        </Route>
      </Route>
      <Route path="auth-page" element={<Navigate to="/" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default TopLevelRoutes
